"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumElement = exports.TealiumFormat = exports.TealiumAction = exports.RFI_INTERSTITIAL_GO_TO_PROFILE_BUTTON = exports.RFI_INTERSTITIAL_CANCEL_LINK = exports.RFI_INTERSTITIAL_CROSS_ICON = exports.RFI_INTERSTITIAL_OPEN_MODAL = void 0;
exports.RFI_INTERSTITIAL_OPEN_MODAL = 'RFI_INTERSTITIAL_OPEN_MODAL';
exports.RFI_INTERSTITIAL_CROSS_ICON = 'RFI_INTERSTITIAL_CROSS_ICON';
exports.RFI_INTERSTITIAL_CANCEL_LINK = 'RFI_INTERSTITIAL_CANCEL_LINK';
exports.RFI_INTERSTITIAL_GO_TO_PROFILE_BUTTON = 'RFI_INTERSTITIAL_GO_TO_PROFILE_BUTTON';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["CLOSE"] = "close";
    TealiumAction["OPEN"] = "open";
    TealiumAction["CLICK"] = "click";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["MODAL"] = "modal";
    TealiumFormat["ICON"] = "icon";
    TealiumFormat["BUTTON"] = "button";
    TealiumFormat["LINK"] = "link";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumElement;
(function (TealiumElement) {
    TealiumElement["FULL"] = "full";
    TealiumElement["CROSS"] = "cross";
})(TealiumElement || (exports.TealiumElement = TealiumElement = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["RFI_MODAL"] = "modal/uploadDocumentation";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["UPDATE_RFI_MODAL"] = "uploadDocumentation";
    TealiumEventAction["CLICK_LINK"] = "clickLink";
    TealiumEventAction["CLICK_BUTTON"] = "clickButton";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=actions.constants.js.map